import {AudioRecordSummaryModel} from '../audioRecordSummary.model';
import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {DocumentSummaryConverter} from '../../../../../../document/common/api/converter/DocumentSummary.converter';
import {PermissionsConverter} from '../../../../../converter/permissions.converter';

@Injectable({
    providedIn: 'root'
})
export class AudioRecordSummaryConverter extends HttpModelConverter<AudioRecordSummaryModel> {

    constructor(private DocumentSummaryConverter: DocumentSummaryConverter,
                private permissionsConverter: PermissionsConverter) {
        super();
    }
    protected createInstance(): AudioRecordSummaryModel {
        return new AudioRecordSummaryModel();
    }

    protected enrichObject(result: AudioRecordSummaryModel, src: AudioRecordSummaryModel) {
        result.document = this.DocumentSummaryConverter.convert(src.document);
        result.permissions = this.permissionsConverter.convert(src.permissions);
    }
}
